import React from "react";
import { Modal, Group, Button, ScrollArea, Box, NativeSelect, Text } from '@mantine/core';
import { DatePicker } from '@mantine/dates';

import { twoDigits, isoDateGetFraction, isoDateTimeBinder } from "../../utils/globalFunctions";

const DateTimePickerModal = ({
    stateData,
    stateShow,
    fnHide,
    stateHideOnClickOutSide = true,
    stateScrollArea = true,

    stateButtonCloseCaption = 'Close',
    stateButtonClosePx = 'md',
    stateButtonCloseSize = 'xs',
    stateButtonCloseVariant = 'light',
    stateButtonCloseColor = '',

    stateButtonActionCaption = 'Submit',
    stateButtonActionPx = 'md',
    stateButtonActionSize = 'xs',
    stateButtonActionVariant = 'filled',
    stateButtonActionColor = '',
    stateButtonActionLoading = false,
    stateOverlayZIndex = null,
    fnButtonAction,
}) => {

    const [data, setData] = React.useState({
        tgl: new Date(),
        jam: '00',
        menit: '00',
    });

    React.useEffect(() => {
        setData(d => ({
            ...d,
            tgl: stateData.valueDate,
            jam: isoDateGetFraction(stateData.valueDate, 'hour', true, '00'),
            menit: isoDateGetFraction(stateData.valueDate, 'minute', true, '00'),
        }))
    }, [stateData.valueDate])

    const jam = () => {
        let res = [];

        for (let index = 0; index < 24; index++) {
            res.push({ value: twoDigits(index), label: twoDigits(index) });
        }

        return res;
    }

    const menit = () => {
        let res = [];

        for (let index = 0; index <= 59; index++) {
            res.push({ value: twoDigits(index), label: twoDigits(index) });
        }

        return res;
    }

    const sxZIndex = stateOverlayZIndex === null ? {} : { zIndex: stateOverlayZIndex }

    return (
        <Modal.Root
            opened={stateShow}
            onClose={fnHide}
            closeOnClickOutside={stateHideOnClickOutSide}
            size='auto'
            centered

            styles={() => ({
                overlay: {
                    // ...{
                    //     opacity: 0.9,
                    //     blur: 6,
                    //     zIndex: 201
                    // },
                    ...sxZIndex
                },
            })}
        >
            <Modal.Overlay />

            <Modal.Content
                scrollAreaComponent={stateScrollArea ? ScrollArea.Autosize : null}
            >
                <Modal.Body>
                    <Group position="center" mt='.5rem'>
                        <DatePicker
                            value={data.tgl}
                            onChange={val => setData(d => ({ ...d, tgl: val }))}
                        />
                    </Group>

                    <Group position="center" noWrap spacing={6} mt='sm'>
                        <NativeSelect
                            value={data.jam}
                            onChange={(e) => setData(d => ({ ...d, jam: e.target.value }))}
                            data={jam()}
                        />

                        <Text>:</Text>

                        <NativeSelect
                            value={data.menit}
                            onChange={(e) => setData(d => ({ ...d, menit: e.target.value }))}
                            data={menit()}
                        />
                    </Group>
                </Modal.Body>

                <Modal.Header sx={{ bottom: 0 }}>
                    <Box sx={{ width: '100%' }}>
                        <Group position='right'>
                            <Button
                                color={stateButtonCloseColor}
                                onClick={fnHide}
                                size={stateButtonCloseSize}
                                variant={stateButtonCloseVariant}
                                px={stateButtonClosePx}
                            >
                                {stateButtonCloseCaption}
                            </Button>

                            <Button
                                color={stateButtonActionColor}
                                size={stateButtonActionSize}
                                variant={stateButtonActionVariant}
                                loaderPosition="right"
                                px={stateButtonActionPx}
                                loading={stateButtonActionLoading}
                                onClick={() => {
                                    fnButtonAction(isoDateTimeBinder(data.tgl, data.jam, data.menit, '00', ''));
                                }}
                            >
                                {stateButtonActionCaption}
                            </Button>
                        </Group>
                    </Box>
                </Modal.Header>
            </Modal.Content>
        </Modal.Root>
    )
}

export default React.memo(DateTimePickerModal);